import { SVGProps } from 'react';

export const IconCloudOff = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M3.515 2.1l19.092 19.092-1.414 1.414-2.627-2.627A6.985 6.985 0 0 1 17 20.25H6.5a5.5 5.5 0 0 1-1.632-10.748A8.014 8.014 0 0 1 5.6 5.6L2.1 2.1l1.415-1.414ZM7.026 7.026a5.982 5.982 0 0 0-.87 2.166l-.161.807-.81.125A3.5 3.5 0 0 0 6.5 18.25H17c.31 0 .612-.04.9-.115L7.027 7.027ZM12 2.25a8 8 0 0 1 7.987 7.502l.012.247.306.047a3.501 3.501 0 0 1 1.626 6.195l-1.45-1.45A1.5 1.5 0 0 0 19.5 12.25h-1l-.1-.998a6 6 0 0 0-8.293-4.871L8.67 4.943A7.963 7.963 0 0 1 12 4.25V2.25Z'
        fill='currentColor'
      />
    </svg>
  );
};
